import React, { useState } from 'react';
import { TIME_LINE_DATA } from '../constants/Experience';

const TimelineItem = ({ title, period, descriptions }) => (
  <div className="group flex gap-2">
    <div className="flex flex-col items-center">
      <div className="h-[7px] border-r border-dashed border-[#66CDCC] group-first:h-0"></div>
      <div className="mt-0 h-2.5 w-2.5 rounded-full bg-teal-400 group-first:mt-[7px]"></div>
      <div className="flex-1 border-r border-dashed border-[#66CDCC]"></div>
    </div>
    <div className="w-[calc(100%-18px)] pb-[30px] group-last:pb-0">
      <div>
        <div className="mb-[13px] flex flex-col gap-[5px]">
          <h3 className="text-base font-normal leading-normal -tracking-[0.32px] text-[#012E33]">
            {title}
          </h3>
          <p className="text-base font-normal leading-normal -tracking-[0.32px] text-[#678285]">
            {period}
          </p>
        </div>
        <div className="pl-4">
          {descriptions.map((description, index) => (
            <ul key={index} className="mb-3 list-disc last:mb-0">
              <li className="text-base font-normal leading-normal -tracking-[0.32px] text-[#678285]">
                {description}
              </li>
            </ul>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const Timeline = ({ items, initialItemsToShow = 1 }) => {
  const [showAll, setShowAll] = useState(false);

  const displayedItems = showAll ? items : items.slice(0, initialItemsToShow);

  return (
    <div className="mx-auto max-w-2xl">
      <div className="pb-7">
        {displayedItems.map((item, index) => (
          <TimelineItem
            key={index}
            title={item.title}
            period={item.period}
            descriptions={item.descriptions}
          />
        ))}
      </div>

      {items.length > initialItemsToShow && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="flex h-10 w-[150px] items-center justify-center rounded-2xl border border-[#66CDCC] px-6 py-2"
        >
          <span className="text-base font-semibold leading-[1] tracking-[0.5px] text-[#66CDCC]">
            {showAll ? 'Show Less' : 'See More...'}
          </span>
        </button>
      )}
    </div>
  );
};

const Experience = () => {
  return <Timeline items={TIME_LINE_DATA} initialItemsToShow={2} />;
};

export default Experience;
